let baseURL = 'https://presencia.mildmac.es/api';
if (window.location.host === 'localhost:5000') {
  baseURL = 'https://control-horario.andressedano.casa/api';
}

import axios from 'axios';

const instance = axios.create({
  withCredentials: true
});

instance.interceptors.request.use(config => {
  config.baseURL = baseURL;
  return config;
});

export default instance;
export const inicializa = () => instance.get('/config/' + location.hostname).then(x => baseURL = x.data);